<template>
  <div class="services">
    <Title :msg="title"></Title>
    <div class="container">
      <div class="row m-auto" style="max-width: 1200px">
        <div class="sidebar col-lg-3">
          <Sidebar/>
        </div>
        <div class="content col-lg-9">
          <router-view/>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
// @ is an alias to /src
import Title from '@/components/title_onecolorbg.vue';
import Sidebar from '@/components/top_Services_sidebar.vue';
import Footer from '@/components/footer_information.vue';

export default {
  data() {
    return {
      title: '服務模式',
    };
  },
  components: {
    Title,
    Sidebar,
    Footer,
  },
};
</script>

<style scoped lang="scss">
.container{
  max-width: 1440px;
  margin: 50px auto;
}
@media screen and (max-width: 1000px){
  .container{
    padding: 0;
  }
  .sidebar{
    order:2
  }
  .content{
    order: 1;
    padding: 0;
    margin: 0;
  }
}

</style>
